import http from "../http-common";
import authHeader from "./authHeader";
import { MEDIA_API } from "../api";

const getAllMedia = () => {
  return http.get(`${MEDIA_API}`);
};
//TODO: in BE
const getAllMediaOfCustomer = (id) => {
  return http.get(`${MEDIA_API}/customer/?id=${id}`, { headers: authHeader() });
};

//get file of employeee
const getFileOfEmployee = (file_name) => {
  return http.get(`${MEDIA_API}/?fileName=${file_name}`, { headers: authHeader() });
};

//TODO: in BE
const getAllMediaOfTypesOfCustomer = (id) => {
  return http.get(`${MEDIA_API}/types/${id}`, { headers: authHeader() });
};

const createMedia = (data) => {
  return http.post(`${MEDIA_API}`, data, { headers: authHeader(), "Content-Type": "multipart/form-data" });
};

const updateMedia = (data) => {
  return http.post(`${MEDIA_API}/update`, data, { headers: authHeader(), "Content-Type": "multipart/form-data" });
};
const getMeidaDocsHQ = (data) => {
  return http.post(`${MEDIA_API}/media-doc-hq`, data, { headers: authHeader() });
};

const MediaService = {
  getAllMedia,
  getFileOfEmployee,
  getAllMediaOfCustomer,
  createMedia,
  updateMedia,
  getAllMediaOfTypesOfCustomer,
  getMeidaDocsHQ,
};

export default MediaService;
